var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_2646)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4182 12.4182 16 8 16C3.58172 16 0 12.4182 0 8C0 3.58172 3.58172 0 8 0C12.4182 0 16 3.58172 16 8ZM8.28672 5.90595C7.50856 6.2296 5.95342 6.89944 3.62126 7.91552C3.24255 8.06616 3.04417 8.21344 3.02611 8.35752C2.99559 8.60096 3.30047 8.69688 3.71565 8.82744C3.77212 8.8452 3.83064 8.8636 3.89062 8.88304C4.29909 9.01584 4.84855 9.1712 5.13419 9.17736C5.3933 9.18296 5.68249 9.07616 6.00176 8.85688C8.1808 7.386 9.3056 6.64256 9.37624 6.62648C9.426 6.6152 9.49504 6.60096 9.54184 6.64256C9.58864 6.68416 9.584 6.76288 9.57904 6.784C9.54888 6.9128 8.35208 8.02544 7.73272 8.6012C7.53968 8.78072 7.40272 8.908 7.37472 8.93712C7.312 9.00224 7.24808 9.06384 7.18664 9.12304C6.8072 9.48888 6.52264 9.7632 7.2024 10.2112C7.52912 10.4265 7.79048 10.6045 8.05128 10.7821C8.33608 10.9761 8.62016 11.1695 8.98776 11.4105C9.08136 11.4718 9.1708 11.5356 9.25792 11.5977C9.58936 11.834 9.8872 12.0462 10.255 12.0124C10.4688 11.9927 10.6897 11.7918 10.8018 11.1922C11.0668 9.77544 11.5878 6.7056 11.7082 5.44065C11.7187 5.32982 11.7054 5.18798 11.6948 5.12572C11.6841 5.06345 11.6618 4.97474 11.5809 4.90906C11.485 4.83129 11.3371 4.81489 11.2709 4.81606C10.97 4.82136 10.5084 4.98188 8.28672 5.90595Z",
    fill: "#B5B7BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_2646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactTelegram);
export default __webpack_public_path__ + "static/media/contact_telegram.078ca9184c67df8c04b2b5862b4eda07.svg";
export { ForwardRef as ReactComponent };